import _defineProperty from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 无品牌产品分享弹框组件
 * <component-nobrand-promotion :share-link="shareLink" v-if="isShopKeeper"></component-nobrand-promotion>
 */
import ComponentNobrandQrcode from "./nobrand_qrcode.vue";
import { updateUrlParam, toast as _toast, showLoading as _showLoading, hideLoading } from '@ykz/ykz-util/base';
import { copy, checkCopyUsable } from '@ykz/ykz-util/platform';
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'nobrandPromotion',
  components: {
    ComponentNobrandQrcode: ComponentNobrandQrcode
  },
  data: function data() {
    return {
      loadProductPromotion: false,
      //渲染产品分享弹框
      showProductPromotion: false,
      //显示产品分享弹框
      productPromotionSlideDown: true,
      //产品分享弹框是否滑下，默认true
      _this: {},
      posterImg: '',
      goodId: getUrlParams('goodId') || '' //商品id
    };
  },

  props: ['shareLink', 'posterLink'],
  //需要分享的链接
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.nobrandPromotion = this;
    console.log('ycf组件初始化：nobrandPromotion');
  },
  methods: _defineProperty(_defineProperty(_defineProperty({
    //显示产品分享弹框
    showShare: function showShare(_this) {
      if (this.loadProductPromotion) {
        this.slideUpProductPromotion(_this);
      } else {
        this.loadProductPromotion = true;
        this.$nextTick(function () {
          this.slideUpProductPromotion(_this);
        });
      }
    },
    //toast
    toast: function toast(str) {
      _toast(str);
    },
    //设置hash值
    setHash: function setHash(str) {
      if (location.hash.replace('#', '') != str) {
        location.hash = str;
      }
    },
    //向上滑动显示产品分享弹框
    slideUpProductPromotion: function slideUpProductPromotion(_this) {
      var _this2 = this;
      this._this != _this && (this._this = _this || {});
      this.showProductPromotion = true;
      setTimeout(function () {
        _this2.productPromotionSlideDown = false;
        _this2.setHash('productPromotion');
      }, 30);
    },
    //向下滑动隐藏产品分享弹框
    slideDownProductPromotion: function slideDownProductPromotion() {
      var _this3 = this;
      this.productPromotionSlideDown = true;
      setTimeout(function () {
        _this3.showProductPromotion = false;
        location.hash == '#productPromotion' && history.go(-1);
      }, 300);
    },
    //复制无品牌链接
    copyNoBrandLink: function copyNoBrandLink() {
      var that = this,
        link = this.shareLink;
      link = updateUrlParam(link, 'channel', 'noBrand'); //带上链接来源
      link = updateUrlParam(link, 'isShop', '1'); //带上店铺模式的标识

      var clearParamList = ['enterMode', 'source', 'tagId', 'tag_id', 'tagName', 'tag_name', 'tag2Id', 'tag2_id', 'tag2Name', 'tag2_name', 'itemId']; //需要清除的参数
      for (var _i = 0, _clearParamList = clearParamList; _i < _clearParamList.length; _i++) {
        var param = _clearParamList[_i];
        link = updateUrlParam(link, param, '');
      }
      while (/&$/.test(link)) {
        link = link.replace(/&$/, '');
      }
      while (/&&/.test(link)) {
        link = link.replace(/&&/g, '&');
      }
      if (checkCopyUsable(10)) {
        copy(link).success(function () {
          that.toast('已复制无品牌链接');
        }).fail(function () {
          that.toast('链接复制失败，请重试！');
        });
      } else {
        that.toast('复制失败，请更新到ios10或以上版本！');
      }
    },
    //显示无品牌二维码弹框
    showQRcode: function showQRcode() {
      componentCenter.nobrandQrcode && componentCenter.nobrandQrcode.showQrcode(this.shareLink);
    },
    showPoster: function showPoster() {}
  }, "toast", function toast(str) {
    _toast(str);
  }), "showLoading", function showLoading(toastText) {
    _showLoading({
      cover: true,
      opacity: 0,
      toastText: toastText
    });
  }), "getPoster", function getPoster(_this) {
    //商详页生成海报
    if (this.posterImg) {
      componentCenter.multiplePosters.showBox(this.posterImg);
      return true;
    }
    if (typeof this.shareLink != 'string') return false;
    var that = this,
      link = this.shareLink;
    // if(this.type == 1) {
    link = updateUrlParam(link, 'channel', 'noBrand');
    // } else {
    // 	link = updateUrlParam(link, "scenicFrom", "noBrand");
    // }
    link = updateUrlParam(link, 'isShop', '1'); //带上店铺模式的标识

    var clearParamList = ['enterMode', 'source', 'tagId', 'tag_id', 'tagName', 'tag_name', 'tag2Id', 'tag2_id', 'tag2Name', 'tag2_name', 'itemId']; //需要清除的参数
    for (var _i2 = 0, _clearParamList2 = clearParamList; _i2 < _clearParamList2.length; _i2++) {
      var param = _clearParamList2[_i2];
      link = updateUrlParam(link, param, '');
    }
    while (/&$/.test(link)) {
      link = link.replace(/&$/, '');
    }
    while (/&&/.test(link)) {
      link = link.replace(/&&/g, '&');
    }
    databus({
      url: '/apiv2/marketing/getPoster',
      type: 'get',
      data: {
        noLogoStore: 1,
        type: 1,
        storeId: _this.couponDetail.isStore && _this.couponDetail.storeData && _this.couponDetail.storeData.storeId || '',
        productId: that.goodId,
        url: link || '',
        rateplan: getUrlParams('rateplan') || '',
        //价格计划加密串
        saleNum: _this.couponDetail.labelType == 1 ? _this.couponDetail.saleNum : 0,
        //销量
        activityEndTime: _this.activityId ? _this.couponDetail.queueEndTime : null //活动结束时间戳
      },

      success: function success(res) {
        if (res.code == 1000 && res.bcode == 100) {
          res.content = res.content || {};
          if (res.content.posterImg && res.content.posterImg.length) {
            that.posterImg = res.content.posterImg;
          } else {
            that.posterImg = '';
          }
        } else {
          that.toast(res.message || '海报图生成失败，请刷新页面重试');
        }
      },
      error: function error() {
        that.toast('网络有误，请重试');
      },
      beforeSend: function beforeSend() {
        that.showLoading();
      },
      complete: function complete() {
        hideLoading();
        if (that.posterImg) {
          componentCenter.multiplePosters.showBox(that.posterImg);
        }
      }
    });
  })
};